// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors-selectwoo","selectwoo-styles"], () => (__webpack_require__("./node_modules/.pnpm/cfwselectwoo@1.0.10/node_modules/cfwselectwoo/dist/js/selectWoo.full.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-selectwoo","selectwoo-styles"], () => (__webpack_require__("./node_modules/.pnpm/cfwselectwoo@1.0.10/node_modules/cfwselectwoo/dist/css/selectWoo.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
